module.exports = __webpack_public_path__ + "img/paysuccess.6db5d7d2.png";